import {
  AbnStatusEnum,
  Contacts,
  EntityTypeEnum,
  GstStatusEnum,
  PermissionEnum,
  WorkspaceCategoryEnum,
} from '@sr-sdks/api-sdk-axios';

export const ManageWorkspacePermissions = [
  PermissionEnum.EditWorkspaceDetails,
  PermissionEnum.EditBankDetails,
  PermissionEnum.EditTeammates,
];

export type WorkspaceOutletContext = {
  isInviteTeammateRequested?: boolean;
  onInviteTeammateHandled?: () => void;
  workspaceId?: string;
};

export interface IBusinessDetailsFields {
  abnStatus?: AbnStatusEnum;
  businessNumber: string;
  businessNumberCountry: string;
  businessNumberVerified: boolean;
  categories: WorkspaceCategoryEnum[];
  entityName: string;
  entityType: EntityTypeEnum;
  gstStatus: GstStatusEnum;
  representsClients: string;
  taxResidency: string;
  workspaceName: string;
}

export interface IWorkspaceDetailsFields
  extends IBusinessDetailsFields, IContactDetailsFields {
  canProceed: boolean;
  workspaceType: string;
}

export interface IAddressFields {
  address: string;
  addressAutocomplete: string;
  city: string;
  country: string;
  postalCode: string;
  state: string;
}

export interface IContactDetailsFields extends IAddressFields {
  contacts?: Contacts;
  emailAddress?: string;
  phone: string;
  website: string;
}
